import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";

import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Savedneighbor
const GQLAddQuestion = gql`
  mutation createquestion(
    $question: String
    $userId: String
    $neighborhoodId: String
    $postedDate: String
    $updatedDate: String
    $lastUpdated: String
  ) {
    createquestion(
      question: $question
      userId: $userId
      neighborhoodId: $neighborhoodId
      postedDate: $postedDate
      updatedDate: $updatedDate
      lastUpdated: $lastUpdated
    ) {
      success
      message
    }
  }
`;

//Update Savedneighbor
const GQLUpdateQuestion = gql`
  mutation updateQuestionandAnswer($id: String!, $neighborhoodId: String) {
    Updatequestionandanswers(id: $id, neighborhoodId: $neighborhoodId) {
      success
      message
    }
  }
`;

//Delete Savedneighbor
const GQLDeleteQuestionandAnswer = gql`
  mutation deleteQuestionandAnswer($id: String!) {
    deletequestionandanswers(id: $id) {
      success
      message
    }
  }
`;

//Get All User
const QUERY_getquestions = gql`
  query getquestions(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $auth_userId: String
  ) {
    getquestions(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
      auth_userId: $auth_userId
    ) {
      id
      userIds
      neighborhoodId
      question
      postedDate
      lastUpdated
      userId {
        id
        type
        firstName
        lastName
        email
        aboutMe
        numberNeighborhoodsReviewed
        questionsAnswered
        realEstateFirm
        license
        phone
        aboutMe
        isagent
        ishomebuyer
        ishomeseller
        isneighbor
        istopagent
        userimage
        displayname
      }
      replies {
        id
        message
        helpContent
        helpfulCount
        helpStatus
        postedDate
        helpedUserId
        firstName
        lastName
        userimage
        type
        realEstateFirm
        replyuserid
        displayname
      }
    }
  }
`;

// const QUERY_getquestions = gql`
// query getquestions($start:Int,$limit:Int,$orderBy:String,$order:String,$fields:String,$auth_userId: String){
//     getquestions(start:$start,limit:$limit,orderBy:$orderBy,order:$order,fields:$fields,auth_userId:$auth_userId){
//         id
//         userId{
//           id
//         }
//         neighborhoodId
//         question
//         postedDate
//         lastUpdated
//         replies{
//           id
//           message
//           postedDate
//           helpContent
//           helpfulCount
//           helpStatus
//           helpedUserId
//           userId{
//             id
//             type
//             firstName
//             lastName
//             email
//             aboutMe
//             numberNeighborhoodsReviewed
//             like
//             questionsAnswered
//             point
//             realEstateFirm
//             license
//             phone
//             aboutMe
//             isagent
//             ishomebuyer
//             ishomeseller
//             isneighbor
//             istopagent
//             userimage
//           }
//         }
//     }
// }
// `;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addquestion(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddQuestion,
        variables: {
          userId: adddata.userId,
          neighborhoodId: adddata.neighborhoodId,
          question: adddata.question,
          postedDate: adddata.postedDate,
          updatedDate: adddata.updatedDate,
          lastUpdated: adddata.lastUpdated,
        },
        options: {
          fetchPolicy: "no-cache",
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updatequestionandanswers(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateQuestion,
        variables: {
          id: updatedata.id,
          neighborhoodId: updatedata.neighborhoodId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deletequestionandanswers(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeleteQuestionandAnswer,
        variables: {
          id: deletedataId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllquestions(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getquestions,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          auth_userId: getdata.auth_userId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export {
  addquestion,
  updatequestionandanswers,
  deletequestionandanswers,
  getAllquestions,
};
